import React, { useState, useEffect } from "react";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import SimpleLink from "../../elements/simple-link";
import Modal from "../../components/Modal";
import "../change-contact-info-modal/style.scss";
const AccountRemoveAddressModal = props => {
  const { headingType, headingBody, subHeadingType, subHeadingBody, body, updateFailedMessage, link, ctaName, colorScheme, iconName, showModal, onSubmit, onModalClose } = props;
  const [updateFailed, setUpdateFailed] = useState(false);
  useEffect(() => {
    setUpdateFailed(false);
  }, [showModal]);
  const modalProps = {
    showModal: showModal,
    onCloseClicked: onModalClose
  };
  const buttonProps = ctaName
    ? {
        buttonText: ctaName.value,
        colorScheme: colorScheme,
        iconName: iconName,
        callback: async evt => {
          try {
            await onSubmit(evt);
          } catch (ex) {
            setUpdateFailed(true);
          }
        }
      }
    : {};
  return (
    <Modal className="change-contact-info-modal" {...modalProps}>
      <Heading type={headingType} html={headingBody} className="heading" />
      <Heading type={subHeadingType} html={subHeadingBody} className="sub-heading" />
      <BodyText className="body" html={body.value} />
      {updateFailed && updateFailedMessage && <BodyText className="failed-message" html={updateFailedMessage.value} />}
      <div className="change-conatct-info-modal-button">
        {ctaName && <PrimaryButton {...buttonProps} />}
        {link && <SimpleLink {...link} />}
      </div>
    </Modal>
  );
};
export default AccountRemoveAddressModal;
